/**
 * PII-safe logging utility
 */

const DEV_MODE = import.meta.env.DEV;

// PII patterns to redact
const PII_PATTERNS = [
  /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g, // emails
  /\b\d{3}-\d{3}-\d{4}\b/g, // phone numbers
  /\b\d{10,}\b/g, // long numbers (account IDs)
  /\b[A-Za-z\s]{2,}\b/g, // names (basic pattern)
];

export function redactPII(text: string): string {
  let redacted = text;
  
  PII_PATTERNS.forEach(pattern => {
    redacted = redacted.replace(pattern, '[REDACTED]');
  });
  
  return redacted;
}

export function safeLog(message: string, data?: any): void {
  if (!DEV_MODE) {
    console.log(message);
    return;
  }
  
  if (data) {
    // Temporarily disabled PII redaction for development debugging
    console.log(message, data);
  } else {
    console.log(message);
  }
}

export function safeLogJSON(message: string, data: any): void {
  if (!DEV_MODE) {
    console.log(message);
    return;
  }
  
  try {
    const jsonString = JSON.stringify(data, null, 2);
    // Temporarily disabled PII redaction for development debugging
    console.log(message);
    console.log(jsonString);
  } catch (error) {
    console.log(message, '[Failed to stringify data]');
  }
}

